// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import {
  FieldError,
  FloatingLabelInput,
  RadioButton,
} from '@checkout/react-components';

// Internal modules
import { blurHandler, changeHandler, focusHandler } from './handlers';
import { InfoIcon } from '../Common/Icons';
import { OnboardTerms } from '../OnboardTerms';
import { SignupFields } from '../SignupFields';
import { passwordStyleOverrides } from '@/styles';
import { useMountLogging } from '@/lib/reactHooks';
import { features, getContent } from '@/lib';
import {
  errorFieldStyleOverrides,
  getRadioButtonStyleOverrides,
} from './styles';
import {
  OptionalAccountFieldset,
  OptionalAccountOption,
  SepaContainer,
} from './StyledComponents';
import { LazySepaMandate } from '../SignupFields/LegalDisclosures/Components';

const OnboardOptions = props => {
  useMountLogging('OnboardOptions');
  const { displayError, error, value } = useStoreState(({ form }) => {
    return form.onboardOption;
  });
  const fiType = useStoreState(({ ui }) => ui.fiType);
  const isBankFiType = fiType === 'bank';
  const isGuest = value === 'guest';
  const isSignup = value === 'signup';
  const isSignUpIneligible = features.isActive('shouldDisableSignup');

  return (
    <>
      {displayError && (
        <FieldError
          icon={<InfoIcon />}
          id="onboardOptionError"
          styleOverrides={errorFieldStyleOverrides}
        >
          {error}
        </FieldError>
      )}

      <OptionalAccountOption>
        <RadioButton
          blurHandler={blurHandler}
          changeHandler={changeHandler}
          checked={isSignup}
          disabled={isSignUpIneligible}
          focusHandler={focusHandler}
          id="onboardOptionSignup"
          label={getContent('fieldLabels.optionalGuest.signup')}
          name="onboardOption"
          value="signup"
          {...getRadioButtonStyleOverrides(displayError, isSignUpIneligible)}
        />

        <OptionalAccountFieldset isSignup={isSignup}>
          {isSignup ? (
            <SignupFields {...props} />
          ) : (
            <FloatingLabelInput
              changeHandler={() => {}}
              disabled={true}
              id="disabledPassword"
              inputStyleOverrides={passwordStyleOverrides}
              label={getContent('fieldLabels.password')}
              value=""
            />
          )}
        </OptionalAccountFieldset>
      </OptionalAccountOption>

      <OptionalAccountOption>
        <RadioButton
          blurHandler={blurHandler}
          changeHandler={changeHandler}
          checked={isGuest}
          focusHandler={focusHandler}
          id="onboardOptionGuest"
          label={getContent('fieldLabels.optionalGuest.guest')}
          name="onboardOption"
          value="guest"
          {...getRadioButtonStyleOverrides(displayError)}
        />

        <OptionalAccountFieldset>
          {isGuest && (
            <OnboardTerms changeHandler={props.changeHandler} type="guest" />
          )}
          {isGuest && features.isActive('hasSepaMandate') && isBankFiType && (
            <SepaContainer>
              <LazySepaMandate changeHandler={props.changeHandler} />
            </SepaContainer>
          )}
        </OptionalAccountFieldset>
      </OptionalAccountOption>
    </>
  );
};

OnboardOptions.propTypes = {
  changeHandler: func,
  focusAndBlurHandler: func,
  methodChangeHandler: func,
};

export { OnboardOptions };
